// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App /> 
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';
// import { Provider } from 'react-redux';
// import { store } from './redux/store';  // If using Redux

// ReactDOM.render(
//   <Provider store={store}> {/* Wrap the App with Provider for Redux */}
//     <App />
//   </Provider>,
//   document.getElementById('root')
// );
// index.js
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import store from './redux/store';
import './i18n'; // Initialize i18n

// Import i18n configuration - this must be imported before any components
import './i18n';

// Suppress ResizeObserver errors (common with Material-UI)
const resizeObserverLoopErrRe = /^[^(ResizeObserver loop limit exceeded)]/;
const resizeObserverLoopErrRe2 = /^ResizeObserver loop completed with undelivered notifications/;
const originalError = console.error;
console.error = (...args) => {
  if (
    resizeObserverLoopErrRe.test(args[0]) ||
    resizeObserverLoopErrRe2.test(args[0])
  ) {
    return;
  }
  originalError.apply(console, args);
};

ReactDOM.render(
  <Provider store={store}>
      <App />
  </Provider>,
  document.getElementById('root')
);
